module.exports = __webpack_public_path__ + "CriticalCraftShoppe.webp?3fcd1f40bd24b042c77940e72eef44ca";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CriticalCraftShoppe.webp
// module id = 68
// module chunks = 0